<div class="ui-g task-control">
  <div class="ui-g-12">
    <div class="ui-g-12" *ngIf="isLoaded; else loading">
      <div class="ui-g">
        <div class="ui-g-6 ui-sm-12 ui-md-6 pl-1">
          <div class="ui-g card" style="min-height: 555px">
            <div class="ui-g-12">
              <div class="ui-g-12 job-info" *ngIf="taskInfo != null">
                <div style="width: 220px; float: left" *ngIf="taskInfo.jobNumber">
                  <div class="header" style="float: left">Job Number:</div>
                  <div style="float: left; margin-left: 10px">
                    {{ taskInfo.jobNumber }}
                  </div>
                </div>
                <div
                  style="width: 160px; height: 10px; float: left"
                  *ngIf="taskInfo.jobNumber"
                ></div>
              </div>
              <div
                class="ui-g-12 customer-info"
                *ngIf="taskInfo != null && taskInfo.customerInfo != null"
              >
                <div class="ui-g-12">
                  {{ taskInfo.customerInfo.name }}
                  <p
                    *ngIf="
                      taskInfo.customerInfo.phone != null && taskInfo.customerInfo.phone.length > 0
                    "
                  >
                    ({{ taskInfo.customerInfo.phone }})
                  </p>
                </div>
                <div
                  class="ui-g-12"
                  *ngIf="
                    taskInfo.customerInfo.email != null && taskInfo.customerInfo.email.length > 0
                  "
                >
                  <a
                    style="color: #3b5169; font-size: 15px"
                    [attr.href]="
                      'mailto:' +
                      taskInfo.customerInfo.email +
                      '?subject=VME: Job Number (' +
                      taskInfo.jobNumber +
                      ')'
                    "
                    class="btn hidden-print"
                    >{{ taskInfo.customerInfo.email }}</a
                  >
                </div>
              </div>

              <div class="ui-g-12">
                <div class="ui-g-6 ui-sm-12">
                  <div style="float: left; width: 100%">
                    <div class="ui-g-12 vehicle-info" *ngIf="taskInfo.vehicle">
                      <div class="ui-g-12">
                        <h3>Vehicle Information</h3>
                      </div>
                      <div
                        class="ui-g-12"
                        *ngIf="taskInfo.vehicle"
                        style="padding-left: 0; word-wrap: break-word"
                      >
                        <div style="width: 220px; float: left">
                          <div>
                            {{ taskInfo.vehicle.make }} {{ taskInfo.vehicle.model }}
                            <span *ngIf="taskInfo.vehicle.registrationNumber">
                              ({{ taskInfo.vehicle.registrationNumber }})
                            </span>
                          </div>
                          <div>Weight: {{ taskInfo.vehicle.kerbWeight }}kg</div>
                        </div>

                        <div style="width: 220px; float: left; margin-top: 20px">
                          <button
                            pButton
                            label="More Details"
                            style="width: auto"
                            (click)="showVehicleDetails()"
                            [disabled]="taskInfo.vehicle == null || taskInfo.vehicle == undefined"
                          ></button>
                        </div>
                      </div>

                      <p-dialog
                        header="Vehicle Details"
                        class="vehicleDetails-op"
                        [(visible)]="isShowVehicleDetails"
                        modal="modal"
                      >
                        <div class="ui-g vehicleDetails-content">
                          <div class="ui-g-12">
                            <div class="ui-g-12">
                              <div class="ui-g-3 ui-lg-3 ui-sm-6 ui-md-6 header">Make:</div>
                              <div class="ui-g-3 ui-lg-3 ui-sm-6 ui-md-6 value">
                                {{ taskInfo.vehicle.make }}
                              </div>
                              <div class="ui-g-3 ui-lg-3 ui-sm-6 ui-md-6 header">Model:</div>
                              <div class="ui-g-3 ui-lg-3 ui-sm-6 ui-md-6 value">
                                {{ taskInfo.vehicle.model }}
                              </div>
                            </div>
                            <div class="ui-g-12">
                              <div class="ui-g-3 ui-lg-3 ui-sm-6 ui-md-6 header">Weight:</div>
                              <div class="ui-g-3 ui-lg-3 ui-sm-6 ui-md-6 value">
                                {{ taskInfo.vehicle.kerbWeight | number }}kg
                              </div>
                              <div class="ui-g-3 ui-lg-3 ui-sm-6 ui-md-6 header">
                                Registration Date:
                              </div>
                              <div class="ui-g-3 ui-lg-3 ui-sm-6 ui-md-6 value">
                                {{ taskInfo.vehicle.registrationDate | date : 'dd/MM/yyyy' }}
                              </div>
                            </div>
                            <div class="ui-g-12">
                              <div class="ui-g-3 ui-lg-3 ui-sm-6 ui-md-6 header">Car Length:</div>
                              <div class="ui-g-3 ui-lg-3 ui-sm-6 ui-md-6 value">
                                {{ taskInfo.vehicle.carLength | number }}mm
                              </div>
                              <div class="ui-g-3 ui-lg-3 ui-sm-6 ui-md-6 header">Color:</div>
                              <div class="ui-g-3 ui-lg-3 ui-sm-6 ui-md-6 value">
                                {{ taskInfo.vehicle.color }}
                              </div>
                            </div>
                            <div class="ui-g-12">
                              <div class="ui-g-3 ui-lg-3 ui-sm-6 ui-md-6 header">Width:</div>
                              <div class="ui-g-3 ui-lg-3 ui-sm-6 ui-md-6 value">
                                {{ taskInfo.vehicle.width | number }}mm
                              </div>
                              <div class="ui-g-3 ui-lg-3 ui-sm-6 ui-md-6 header">Height:</div>
                              <div class="ui-g-3 ui-lg-3 ui-sm-6 ui-md-6 value">
                                {{ taskInfo.vehicle.height | number }}mm
                              </div>
                            </div>
                            <div class="ui-g-12">
                              <div class="ui-g-3 ui-lg-3 ui-sm-6 ui-md-6 header">Size Engine:</div>
                              <div class="ui-g-3 ui-lg-3 ui-sm-6 ui-md-6 value">
                                {{ taskInfo.vehicle.sizeEngine | number }}cc
                              </div>
                              <div class="ui-g-3 ui-lg-3 ui-sm-6 ui-md-6 header">
                                Number Of Axles:
                              </div>
                              <div class="ui-g-3 ui-lg-3 ui-sm-6 ui-md-6 value">
                                {{ taskInfo.vehicle.numberOfAxles }}
                              </div>
                            </div>
                            <div class="ui-g-12">
                              <div class="ui-g-3 ui-lg-3 ui-sm-6 ui-md-6 header">Body:</div>
                              <div class="ui-g-3 ui-lg-3 ui-sm-6 ui-md-6 value">
                                {{ taskInfo.vehicle.body }}
                              </div>
                              <div class="ui-g-3 ui-lg-3 ui-sm-6 ui-md-6 header">
                                Wheelbase Length:
                              </div>
                              <div class="ui-g-3 ui-lg-3 ui-sm-6 ui-md-6 value">
                                {{ taskInfo.vehicle.wheelbaseLength }}
                              </div>
                            </div>
                            <div class="ui-g-12"></div>
                          </div>
                        </div>
                      </p-dialog>
                    </div>

                    <div
                      class="ui-g-12 additional-info"
                      *ngIf="
                        taskInfo.additionalInformation && taskInfo.additionalInformation.length > 0
                      "
                    >
                      <div class="ui-g-12">
                        <h3>Additional information</h3>
                      </div>
                      <div id="AdditionalInformation" class="ui-g-12 value">
                        {{ taskInfo.additionalInformation }}
                      </div>
                    </div>

                    <div style="clear: both"></div>
                  </div>
                </div>

                <div class="ui-g-6 ui-sm-12 route-info">
                  <div class="route-info-data" *ngIf="routeInfo">
                    <div class="ui-g">
                      <div class="ui-g-6 route-info-parameter">Type:</div>
                      <div class="ui-g-6">{{ taskType }}</div>
                    </div>

                    <div class="ui-g">
                      <div class="ui-g-6 route-info-parameter" route-info-parameter>Distance:</div>
                      <div class="ui-g-6">{{ routeInfo.distanceMiles }} miles</div>
                    </div>

                    <div class="ui-g">
                      <div class="ui-g-6 route-info-parameter" route-info-parameter>
                        Estimated Time:
                      </div>
                      <div class="ui-g-6">{{ routeInfo.time }}</div>
                    </div>
                  </div>
                </div>

                <div class="ui-g-12">
                  <h3>Journey Information</h3>

                  <div class="ui-g-6 ui-sm-12">
                    <!--<div class="ui-g-12">
                        <div class="pick-up-color" style="position:relative">
                            <i class="vme-material-icons route-icon">&#xe805;</i>
                            <div style="margin-left: 2em; font-weight:bold; font-size: 16px">
                                Pick-up
                            </div>
                        </div>


                    </div>-->

                    <div class="pick-up-column ui-g-12">
                      <div class="label" style="float: left">
                        <i class="vme-material-icons">&#xe805;</i> Pick-up
                      </div>
                    </div>

                    <div class="ui-g-12">
                      <div
                        class="ui-g-4"
                        style="margin-top: 5px; font-weight: bold; padding-right: 5px"
                      >
                        Location
                      </div>
                      <div class="ui-g-8" style="margin-top: 5px">
                        <div>{{ taskInfo.pickupLocation?.businessName }}</div>
                        <div *ngIf="taskInfo.pickupLocation">
                          <div
                            *ngFor="
                              let item of taskInfo.pickupLocation.primaryAddress
                                .replace(taskInfo.pickupLocation.postcode, '')
                                .split(',')
                            "
                          >
                            {{ item }}
                          </div>
                          <div>{{ taskInfo.pickupLocation.postcode | postcode }}</div>
                        </div>
                      </div>
                    </div>

                    <div class="ui-g-12">
                      <div
                        class="ui-g-4"
                        style="margin-top: 5px; font-weight: bold; padding-right: 5px"
                      >
                        Earliest time
                      </div>
                      <div class="ui-g-8" style="margin-top: 5px">
                        {{ taskInfo.pickupEarliestDateTime | datex : 'ddd DD MMM HH:mm' }}
                      </div>
                    </div>

                    <div class="ui-g-12">
                      <div
                        class="ui-g-4"
                        style="margin-top: 5px; font-weight: bold; padding-right: 5px"
                      >
                        Latest time
                      </div>
                      <div class="ui-g-8" style="margin-top: 5px">
                        {{ taskInfo.pickupLatestDateTime | datex : 'ddd DD MMM HH:mm' }}
                      </div>
                    </div>
                  </div>

                  <div class="ui-g-6 ui-sm-12">
                    <!--<div class="ui-g-12">
                        <div class="drop-off-color" style="position:relative">
                            <i class="vme-material-icons route-icon">&#xe804;</i>
                            <div style="margin-left: 2em; font-weight:bold; font-size: 16px">
                                Drop-off
                            </div>
                        </div>
                    </div>-->

                    <div class="drop-off-column ui-g-12">
                      <div class="label" style="float: left">
                        <i class="vme-material-icons">&#xe804;</i> Drop-off
                      </div>
                    </div>

                    <div class="ui-g-12">
                      <div
                        class="ui-g-4"
                        style="margin-top: 5px; font-weight: bold; padding-right: 5px"
                      >
                        Location
                      </div>
                      <div class="ui-g-8" style="margin-top: 5px">
                        <div *ngIf="taskInfo.dropoffLocation">
                          <div>{{ taskInfo.dropoffLocation?.businessName }}</div>
                          <div
                            *ngFor="
                              let item of taskInfo.dropoffLocation.primaryAddress
                                .replace(taskInfo.dropoffLocation.postcode, '')
                                .split(',')
                            "
                          >
                            {{ item }}
                          </div>
                          <div>{{ taskInfo.dropoffLocation.postcode | postcode }}</div>
                        </div>
                      </div>
                    </div>

                    <div class="ui-g-12">
                      <div
                        class="ui-g-4"
                        style="margin-top: 5px; font-weight: bold; padding-right: 5px"
                      >
                        Earliest time
                      </div>
                      <div class="ui-g-8" style="margin-top: 5px">
                        {{ taskInfo.dropoffEarliestDateTime | datex : 'ddd DD MMM HH:mm' }}
                      </div>
                    </div>

                    <div class="ui-g-12">
                      <div
                        class="ui-g-4"
                        style="margin-top: 5px; font-weight: bold; padding-right: 5px"
                      >
                        Latest time
                      </div>
                      <div class="ui-g-8" style="margin-top: 5px">
                        {{ taskInfo.dropoffLatestDateTime | datex : 'ddd DD MMM HH:mm' }}
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngIf="!isGuranteeFulfilment" class="ui-g-12 gurantee-fulfilment-message">
                  Fulfillment not guaranteed given the notice period on this movement type; we will
                  work to find a supplier and confirm when we have done so.
                </div>

                <div
                  class="ui-g-12 additional-info"
                  *ngIf="getNotes(taskInfo.notes, true).length > 0"
                >
                  <p-fieldset
                    legend="Pick-up Notes"
                    styleClass="adjustmentFieldset"
                    [toggleable]="true"
                  >
                    <div
                      class="ui-g-12 value"
                      *ngFor="let note of getNotes(taskInfo.notes, true); let i = index"
                      [class.note-even]="i % 2 == 0"
                      [class.note-odd]="i % 2 == 1"
                    >
                      {{ note.description }}
                    </div>
                  </p-fieldset>
                </div>

                <div
                  class="ui-g-12 additional-info"
                  *ngIf="getNotes(taskInfo.notes, false).length > 0"
                >
                  <p-fieldset
                    legend="Drop-off Notes"
                    styleClass="adjustmentFieldset"
                    [toggleable]="true"
                  >
                    <div
                      class="ui-g-12 value"
                      *ngFor="let note of getNotes(taskInfo.notes, false); let i = index"
                      [class.note-even]="i % 2 == 0"
                      [class.note-odd]="i % 2 == 1"
                    >
                      {{ note.description }}
                    </div>
                  </p-fieldset>
                </div>
                <div class="ui-g-12 access-numbers">
                  <h3>Access Numbers</h3>
                  <div class="ui-g-12">
                    <div class="ui-g-4 ui-sm-12 mt-2">Release Code:</div>
                    <div class="ui-g-8 ui-sm-12 mt-2">
                      {{ taskInfo.releaseCode }}
                    </div>
                  </div>
                  <div *ngIf="showMoDelPinContainer" class="ui-g-12">
                    <div class="ui-g-4 ui-sm-12 mt-2">MoDeL PIN:</div>
                    <div class="ui-g-8 ui-sm-12 mt-2">
                      {{ taskInfo.moDelPin }}
                    </div>
                  </div>
                </div>
                <div class="ui-g-12 further-information">
                  <h3>Further Information</h3>
                  <div class="ui-g-12">
                    <div
                      class="ui-g-4"
                      style="margin-top: 5px; font-weight: bold; padding-right: 5px"
                    >
                      Purchase Order No
                    </div>
                    <div class="ui-g-8" style="margin-top: 5px; padding-right: 5px">
                      <input
                        name="purchaseOrderNo"
                        type="text"
                        maxlength="50"
                        pInputText
                        style="width: 100%; margin-right: 5px"
                        [(ngModel)]="taskInfo.furtherInformation.purchaseOrderNo"
                      />
                    </div>
                  </div>
                  <div class="ui-g-12">
                    <div class="ui-g-4 ui-sm-12 mt-2">Department Code</div>
                    <div class="ui-g-8 ui-sm-12 mt-2">
                      <p-dropdown
                        name="accountCode"
                        [options]="accountCodes"
                        [(ngModel)]="taskInfo.furtherInformation.accountCode"
                        [style]="{ width: '100%' }"
                      ></p-dropdown>
                    </div>
                  </div>
                  <div class="ui-g-12">
                    <div class="ui-g-4 ui-sm-12 mt-2">Job Tagging</div>
                    <div class="ui-g-8 ui-sm-12 mt-2">
                      <p-multiSelect
                        name="orderTags"
                        [options]="orderTags"
                        [(ngModel)]="taskInfo.furtherInformation.orderTags"
                        [style]="{ width: '100%' }"
                        [required]="
                          isJobTaggingEnforced && !taskInfo.furtherInformation.orderTags?.length
                        "
                      ></p-multiSelect>
                      <div class="text-danger">
                        <small
                          *ngIf="
                            isJobTaggingEnforced && !taskInfo.furtherInformation.orderTags?.length
                          "
                        >
                          At least one job tag is required.
                        </small>
                      </div>
                    </div>
                  </div>
                  <!---
                  <div class="ui-g-12">
                    <div class="ui-g-4 ui-sm-12 mt-2">Department</div>
                    <div class="ui-g-8 ui-sm-12 mt-2">
                      <p-dropdown
                        name="departments"
                        required
                        [options]="departments"
                        (onChange)="departmentChange($event)"
                        [(ngModel)]="customerDepartmentId"
                        [style]="{ width: '100%' }"
                      ></p-dropdown>
                      <div [hidden]="customerDepartmentId" class="alert alert-danger">
                        Please select a department
                      </div>
                    </div>
                  </div>

                  <div class="ui-g-12">
                    <div class="ui-g-4 ui-sm-12 mt-2">Team</div>
                    <div class="ui-g-8 ui-sm-12 mt-2">
                      <p-dropdown
                        name="teams"
                        required
                        [options]="teams"
                        [(ngModel)]="customerTeamId"
                        (onChange)="teamChange($event)"
                        [style]="{ width: '100%' }"
                      ></p-dropdown>
                      <div [hidden]="customerTeamId" class="alert alert-danger">
                        Please select a team
                      </div>
                    </div>
                  </div>

                  -->

                  <div
                    class="ui-g-12"
                    *ngIf="
                      userOrg?.organisationTypeId == organisationTypeEnum.Engineius ||
                      isUserImpersonated
                    "
                  >
                    <div class="ui-g-4 ui-sm-12 mt-2">Charging Fees</div>
                    <div class="ui-g-8 ui-sm-12 mt-2">
                      <p-multiSelect
                        name="customerServiceFee"
                        [options]="customerServiceFeeOptions"
                        [(ngModel)]="customerServiceFeeIds"
                        (onChange)="chargingFeeChange($event)"
                        [style]="{ width: '100%' }"
                      ></p-multiSelect>
                    </div>
                  </div>

                  <p-dialog
                    header="Confirm Notifications"
                    class="-op"
                    [(visible)]="confirmNotifications"
                    modal="modal"
                  >
                    <p>
                      This {{ confirmNotificationEntity }} has requested
                      {{ confirmNotificationTypes.join(' & ') }} notifications.
                    </p>

                    <p>OK to enable notifications ?</p>

                    <div class="notification-buttons">
                      <button
                        pButton
                        label="Yes"
                        class="ui-button primary"
                        style="width: auto"
                        (click)="
                          EnableNotifications(
                            this.confirmNotificationEntity,
                            this.confirmNotificationTypes
                          )
                        "
                      ></button>
                      <button
                        pButton
                        label="No"
                        class="ui-button"
                        style="width: auto"
                        (click)="this.confirmNotifications = false"
                      ></button>
                    </div>
                  </p-dialog>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ui-g-6 ui-sm-12 ui-md-6 pl-1 map-container-div">
          <map-control
            style="height: 100%"
            [origin]="taskInfo.pickupLocation"
            [destination]="taskInfo.dropoffLocation"
            [earliestPickup]="taskInfo.pickupEarliestDateTime"
            [readOnly]="true"
            [customStyle]="{ height: '600px' }"
          >
          </map-control>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #loading>
  <div style="height: 300px; width: 100%">
    <img
      src="assets/images/loader.gif"
      style="margin-left: 45%; margin-top: 5%"
      width="50"
      height="50"
      alt="load"
    />
  </div>
</ng-template>
